import Vue from "vue";
import { createInertiaApp } from "@inertiajs/vue2";
import { createPinia, PiniaVuePlugin } from "pinia";
import { Tooltip } from "bootstrap";
import Layout from "@landing/Layout/Master";
import VueToast from "vue-toast-notification";
import Select2 from "v-select2-component";
import { Button, Image as VanImage, Lazyload, Divider, Locale } from "vant";
import "@vant/touch-emulator";
import enUS from "vant/es/locale/lang/en-US";

Locale.use("en-US", enUS);

// Laravel Locale for vue js
Vue.mixin(require("../trans"));

// App Bootstrap
require("./bootstrap");

// PiniaJs
const pinia = createPinia();

createInertiaApp({
    title: (title) => (title ? title : process.env.MIX_APP_NAME),
    progress: {
        delay: 100,
        color: "#ED8936",
        includeCSS: true,
        showSpinner: false,
    },
    resolve: (name) => {
        const page = require(`./Pages/${name}`).default;
        page.layout = page.layout || Layout;
        return page;
    },
    setup({ el, App, props, plugin }) {
        Vue.use(plugin);

        // Pinia Js
        Vue.use(PiniaVuePlugin);

        // Vue Toast
        Vue.use(VueToast, {
            position: "bottom-right",
            duration: 3000,
        });

        // Select2
        Vue.component("Select2", Select2);

        // Vant
        Vue.use(Button);
        Vue.use(VanImage);
        Vue.use(Lazyload);
        Vue.use(Divider);

        // Setup bootstrap tooltip globally (eg. v-btooltip:top="Hello World")
        Vue.directive("btooltip", function (el, binding) {
            if (!window.matchMedia("(max-width: 575px)").matches) {
                return new Tooltip(el, {
                    title: binding.value,
                    placement: binding.arg,
                    trigger: "hover",
                });
            }
        });

        window.addEventListener("click", function () {
            if (document.querySelector(".tooltip")) {
                document.querySelector(".tooltip").remove();
            }
        });

        new Vue({
            pinia,
            render: (h) => h(App, props),
        }).$mount(el);
    },
});
